import './App.css';
import { HelmetProvider } from 'react-helmet-async';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
// import component
import Home from './Home/Home.js';
import Navbar from './Navbar/Navbar.js';
import Footer from './Footer/Footer.js';
import About from './About/About.js';
import AllDoctors from './AllDoctors/AllDoctors.js';
import Contact from './Contact/Contact.js';
import Services from './Services/Services.js';
import ServiceDetail from './Services/ServiceDetail.js';
import HealthTips from './HealthTips/HealthTips.js';
import CentresOfExcellence from './Home/CentresOfExcellence.js';
import Blog from './Blog/Blog.js';
import Facilities from './Facilities/Facilities.js';
import Careers from './Careers/Careers.js';
import Chatbot from './Chatbot/Chatbot.js';



// import AppContext
import AppContextProvider from './Context/AppContext.js';

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Page transition component
const pageVariants = {
  initial: {
    opacity: 0,
    y: 10, // Reduced movement for subtlety
    scale: 0.99 // Slight scale effect
  },
  in: {
    opacity: 1,
    y: 0,
    scale: 1
  },
  out: {
    opacity: 0,
    y: -10, // Reduced movement
    scale: 0.99
  },
};

const pageTransition = {
  type: 'tween',
  ease: [0.43, 0.13, 0.23, 0.96], // Custom bezier for "smooth" feel
  duration: 0.6, // Slightly slower
};

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path='/'
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <Home />
            </motion.div>
          }
        />
        <Route
          path='/Home'
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <Home />
            </motion.div>
          }
        />
        <Route
          path='/famous-specialities'
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <CentresOfExcellence />
            </motion.div>
          }
        />
        <Route
          path='/About'
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <About />
            </motion.div>
          }
        />
        <Route
          path='/Services'
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <Services />
            </motion.div>
          }
        />
        <Route
          path='/services/:serviceSlug'
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <ServiceDetail />
            </motion.div>
          }
        />
        <Route
          path='/AllDoctors'
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <AllDoctors />
            </motion.div>
          }
        />
        <Route
          path='/doctors'
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <AllDoctors />
            </motion.div>
          }
        />
        <Route
          path='/doctors/:speciality'
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <AllDoctors />
            </motion.div>
          }
        />
        <Route
          path='/Contact'
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <Contact />
            </motion.div>
          }
        />
        <Route
          path='/HealthTips'
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <HealthTips />
            </motion.div>
          }
        />
        <Route
          path='/Blog'
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <Blog />
            </motion.div>
          }
        />
        <Route
          path='/facilities'
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <Facilities />
            </motion.div>
          }
        />
        <Route
          path='/careers'
          element={
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <Careers />
            </motion.div>
          }
        />
      </Routes>
    </AnimatePresence>
  );
}


function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <AppContextProvider>
            <Navbar />
            <AnimatedRoutes />
            <Chatbot />
          </AppContextProvider>
          <Footer />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
